<template>
  <ValidationField
    v-slot="{ field, errors }"
    v-model="inputValue"
    :name="name"
    as="div"
    :rules="rules"
    :vid="vid"
    :class="{
      'w-full': fullWidth
    }"
  >
    <div
      :class="{
        'text-area-field': true,
        'text-area-field--focus': focus
      }"
    >
      <span
        v-if="label"
        class="text-area-field__label"
      >{{ label }}</span>
      <vs-textarea
        v-bind="field"
        v-model="inputValue"
        :rows="rows"
        :placeholder="placeholder"
        class="m-0"
        :disabled="disabled"
        @focus="focus = true"
        @focusout="focus = false"
      />
      <div
        v-if="errors.length > 0"
        style="height: 26px;"
        class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
      >
        <span class="span-text-validation">
          {{ errors[0] }}
        </span>
      </div>
    </div>
  </ValidationField>
</template>

<script>
export default {
  name: 'TextAreaField',
  props: {
    modelValue: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    rows: {
      type: String,
      default: '2'
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      focus: false
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        return this.$emit('update:modelValue', newValue)
      }
    }
  }
}
</script>

<style>
.text-area-field--focus .text-area-field__label {
  color: rgba(var(--vs-primary),1)!important;
}
.text-area-field .text-area-field__label {
  letter-spacing: 0.01rem;
  direction: ltr;
  --vs-light: 245,245,245;
  --vs-primary: 115,103,240;
  --vs-success: 40,199,111;
  --vs-danger: 234,84,85;
  --vs-warning: 255,159,67;
  --vs-dark: 30,30,30;
  --vh: 8.14px;
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  font-weight: 400;
  line-height: 2 !important;
  text-align: left !important;
  margin: 0;
  box-sizing: border-box;
  outline: none;
  text-transform: none;
  text-decoration: none;
  font-size: .85rem;
  color: rgba(0,0,0,.7);
  padding: 0 0 0 5px;
}
</style>
